//Components
const PuppyPurchaseTransaction = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "puppy-purchase-transaction" */ "@/app/views/client-view/puppy-for-sale-page/components/puppy-purchase-pay-now-page/puppy-purchase-pay-now-page.vue"
	)
const ClientHeader = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "client-header" */ "@/app/views/client-view/_shared/client-header/client-header.vue"
	)
const TheFooter = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "the-footer" */ "@/app/views/main-view/_shared/the-footer/the-footer.vue"
	)

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"

//Service
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"

import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"

export default {
	name: "PuppyPurchasePayNowContainer",
	components: { PuppyPurchaseTransaction, ClientHeader, TheFooter },
	mixins: [toastMessageMixins],
	data() {
		return {
			puppyPurchaseDetails: null,
			isAPILoading: true,
		}
	},
	computed: {
		isNativeApp() {
			return this.$store.getters.getIsNativeApp
		},
	},
	watch: {},
	created() {
		const { referenceId, token } = this.$route.query
		this.getPuppyPurchaseDetailsPayment(referenceId, token)
	},
	methods: {
		getPuppyPurchaseDetailsPayment(referenceId, token) {
			this.isAPILoading = true
			const queryParams = {
				f_referenceNumber: referenceId,
				f_token: token,
			}
			puppySellService
				.getPuppyPurchaseDetailsPayment(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.puppyPurchaseDetails = res.data
					}
				})
				.catch((err) => {
					this.showAPIErrorToast("Unable to fetch puppy purcahse payment details.", err)
				})
				.finally(() => {
					this.isAPILoading = false
				})
		},
	},
	// third party libraries
}
